import MicroModal from "micromodal"
import Button from "../button/Button";
import Icons from "../icons/Icons";

const Modal = ({ 
  modalId, 
  buttonTitle, 
  classNames, 
  modalClassNames, 
  containerClassNames, 
  modalHeading, 
  showModalHeader = true, 
  children 
}) => {

  const hasClassNames = classNames ? classNames : "button"
  
  return (
    <>
      {
        buttonTitle !== '' && (
          <button type='button' className={ hasClassNames } onClick={() => MicroModal.show( modalId )}>{ buttonTitle }</button>
        )
      }
      <div key={ modalId } className={`msync-modal ${modalClassNames ?? ''}`} id={ modalId } aria-hidden="true" data-msync-micromodal-animation="slide">
        <div className="msync-modal__overlay" tabIndex="-1">
          <div className={`msync-modal__container ${containerClassNames ?? ''}`} role="dialog" aria-modal="true" aria-labelledby={ `${modalId}-label` }>
            
            {showModalHeader && (
              <header className="msync-modal__header">
                <div className="msync-modal__header__title">
                  {modalHeading && (
                    <h2 className="msync-modal__title msync-modal__header__title__text" id={ `${modalId}-label` }>{modalHeading}</h2>
                  )}
                </div>
                <Button 
                  className="msync-modal__close" 
                  aria-label="Close modal" 
                  onClick={()=>MicroModal.close( modalId )}
                >
                  <Icons type='close' />
                  <span className="msync-visually-hidden">Close <kbd>ESC</kbd></span>
                </Button>
              </header>
            )}
            
            { children }
          </div>
        </div>
      </div>
    </>
  )
}

export default Modal
